module.exports = __webpack_public_path__ + "img/guide00.34f61197.png";